export default `:host{
    --_ui5_banner_background: var(--sapShell_HeroBanner_Background);
    --_ui5_banner_text_color: var(--sapShell_HeroBanner_TextColor);
    --_ui5_banner_border_radius: var(--sapTile_BorderCornerRadius);
    --_ui5_banner_box_shadow: var(--sapContent_Shadow0);
    --_ui5_banner_background_image: var(--sapShell_HeroBanner_BackgroundImage);
    --_ui5_fcl_solid_bg: var(--sapBackgroundColor);
    --_ui5_fcl_column_border: solid .0625rem var(--sapGroup_ContentBorderColor);
    --_ui5_fcl_decoration_top: linear-gradient(to top, var(--sapObjectHeader_BorderColor), #fff);
    --_ui5_fcl_decoration_bottom: linear-gradient(to bottom, var(--sapObjectHeader_BorderColor), #fff);
    --_ui5_media_gallery_overflow_btn_background: var(--sapButton_Background);
    --_ui5_media_gallery_overflow_btn_color: var(--sapButton_TextColor);
    --_ui5_media_gallery_overflow_btn_border: 1px solid var(--sapButton_BorderColor);
    --_ui5_media_gallery_thumbnail_border: 1px solid var(--sapContent_ForegroundColor);
    --_ui5_media_gallery_thumbnail_selected_border: 2px solid var(--sapSelectedColor);
    --_ui5_media_gallery_thumbnail_focus_outline: var(--sapContent_FocusWidth) var(--sapContent_FocusStyle) var(--sapContent_FocusColor);
    --_ui5_media_gallery_item_overlay_box_shadow: inset 0px 0px 80px rgba(0, 0, 0, .2);
    --_ui5_page_list_bg: var(--sapGroup_ContentBackground);
    --_ui5_page_transparent_bg: var(--sapBackgroundColor);
    --_ui5_product_switch_item_width: 11.25rem;
    --_ui5_product_switch_item_height: 7rem;
    --_ui5_product_switch_item_active_outline_color: var(--sapContent_ContrastFocusColor);
    --_ui5_product_switch_item_outline_offset: -.25rem;
    --_ui5_product_switch_item_border: 1px solid var(--sapField_BorderColor);
    --_ui5_shellbar_root_height: 2.75rem;
    --_ui5_shellbar_button_border: none;
    --_ui5_shellbar_button_border_radius: .25rem;
    --_ui5_shellbar_button_focused_border: .125rem dotted var(--sapContent_FocusColor);
    --_ui5_shellbar_button_badge_border: 1px solid var(--sapGroup_ContentBorderColor);
    --_ui5_shellbar_outline_offset: -.0625rem;
    --_ui5_shellbar_search_field_outline_focused: .0625rem dotted var(--sapContent_ContrastFocusColor);
    --_ui5_shellbar_search_field_background_hover: var(--sapShellColor);
    --_ui5_shellbar_search_field_box_shadow_hover: none;
    --_ui5_shellbar_menu_button_title_font_size: .75rem;
    --_ui5_side_navigation_width: 16rem;
    --_ui5_side_navigation_collapsed_width: 3rem;
    --_ui5_side_navigation_navigation_separator_margin: .25rem .5rem .25rem .5rem;
    --_ui5_side_navigation_navigation_separator_background_color: var(--sapList_GroupHeaderBorderColor);
    --_ui5_side_navigation_navigation_separator_radius: unset;
    --_ui5_side_navigation_navigation_separator_height: calc(2 * var(--sapList_BorderWidth));
    --_ui5_side_navigation_triangle_color: var(--sapContent_IconColor);
    --_ui5_side_navigation_border_right: 1px solid var(--sapGroup_ContentBorderColor);
    --_ui5_side_navigation_box_shadow: var(--sapContent_Shadow0);
    --_ui5_side_navigation_triangle_display: block;
    --_ui5_side_navigation_icon_color: var(--sapContent_IconColor);
    --_ui5_side_navigation_expand_icon_color: var(--sapContent_IconColor);
    --_ui5_side_navigation_expand_icon_width: 2rem;
    --_ui5_side_navigation_hover_border_style_color: none;
    --_ui5_side_navigation_hover_border_width: 0;
    --_ui5_side_navigation_group_border_style_color: solid var(--sapList_BorderColor);
    --_ui5_side_navigation_group_border_width: 0 0 .0625rem 0;
    --_ui5_side_navigation_item_border_style_color: none;
    --_ui5_side_navigation_item_border_width: 0;
    --_ui5_side_navigation_item_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.5rem);
    --_ui5_side_navigation_item_margin: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, .875rem);
    --_ui5_side_navigation_item_expand_arrow_padding: var(--_ui5-compact-size, .3125rem)  var(--_ui5-cozy-size, .6875rem);
    --_ui5_side_navigation_item_border_radius: 0;
    --_ui5_side_navigation_item_bottom_margin: 0;
    --_ui5_side_navigation_item_padding_start_in_popup: var(--_ui5_side_navigation_group_icon_width);
    --_ui5_side_navigation_item_padding_start_in_overflow_popup: .75rem;
    --_ui5_side_navigation_item_transition: none;
    --_ui5_side_navigation_item_padding_left: .5rem;
    --_ui5_side_navigation_item_focus_border_offset: 1px;
    --_ui5_side_navigation_item_focus_border_radius: var(--_ui5_side_navigation_item_border_radius);
    --_ui5_side_navigation_collapsed_selected_item_background: 0 100% / 100% .0625rem no-repeat linear-gradient(0deg, var(--sapList_SelectionBorderColor), var(--sapList_SelectionBorderColor)), var(--sapList_SelectionBackgroundColor);
    --_ui5_side_navigation_collapsed_selected_item_background_hover: 0 100% / 100% .0625rem no-repeat linear-gradient(0deg, var(--sapList_SelectionBorderColor), var(--sapList_SelectionBorderColor)), var(--sapList_Hover_SelectionBackground);
    --_ui5_side_navigation_selected_item_border_color: var(--sapList_SelectionBorderColor);
    --_ui5_side_navigation_selected_border_style_color: solid var(--_ui5_side_navigation_selected_item_border_color);
    --_ui5_side_navigation_selected_and_focused_border_style_color: var(--_ui5_side_navigation_selected_border_style_color);
    --_ui5_side_navigation_selected_border_width: 0 0 .0625rem 0;
    --_ui5_side_navigation_group_expanded_border_width: 0;
    --_ui5_side_navigation_group_icon_width: var(--_ui5_side_navigation_collapsed_width);
    --_ui5_side_navigation_icon_padding_inline_end: .4375rem;
    --_ui5_side_navigation_item_font_family: var(--sapFontFamily);
    --_ui5_side_navigation_parent_item_font_family: var(--sapFontSemiboldDuplexFamily);
    --_ui5_side_navigation_group_padding: .5rem;
    --_ui5_side_navigation_padding-flexible: 0;
    --_ui5_side_navigation_padding-fixed: 0;
    --_ui5_side_navigation_popup_padding: 0;
    --_ui5_side_navigation_popup_title_line_height: normal;
    --_ui5_side_navigation_first_fixed_item_margin_top: 0;
    --_ui5_side_navigation_item_expand_icon_visibility: none;
    --_ui5_side_navigation_item_collapsed_hover_focus_width: auto;
    --_ui5_side_navigation_item_collapsed_hover_focus_display: none;
    --_ui5_side_navigation_item_collapsed_hover_focus_padding_right: 0;
    --_ui5_side_navigation_action_item_collapsed_padding: 0;
    --_ui5_side_navigation_item_collapsed_padding: 0;
    --_ui5_side_navigation_action_item_border_hover: var(--sapButton_BorderWidth) solid var(--sapButton_Hover_BorderColor);
    --_ui5_side_navigation_action_item_border_active: var(--sapButton_BorderWidth) solid var(--sapButton_Active_BorderColor);
    --_ui5_side_navigation_item_expand_icon_right: -.5rem;
    --_ui5_side_navigation_item_expand_icon_hover_left: auto;
    --_ui5_side_navigation_item_expand_icon_hover_right: 0;
    --_ui5_side_navigation_active_text_color: var(--sapList_Active_TextColor);
    --_ui5_TimelineItem_arrow_size: 1.625rem;
    --_ui5_TimelineItem_bubble_border_width: .0625rem;
    --_ui5_TimelineItem_bubble_border_style: dotted;
    --_ui5_TimelineItem_bubble_border_radius: .25rem;
    --_ui5_TimelineItem_bubble_border_color: var(--sapList_BorderColor);
    --_ui5_TimelineItem_bubble_border_top: -.125rem;
    --_ui5_TimelineItem_bubble_border_right: -.125rem;
    --_ui5_TimelineItem_bubble_border_bottom: -.125rem;
    --_ui5_TimelineItem_bubble_border_left: -.625rem;
    --_ui5_TimelineItem_bubble_rtl_left_offset: -.1875rem;
    --_ui5_TimelineItem_bubble_rtl_right_offset: -.6875rem;
    --_ui5_TimelineItem_bubble_focus_border_radius: 0;
    --_ui5_TimelineItem_horizontal_bubble_focus_top_offset: -.625rem;
    --_ui5_TimelineItem_horizontal_bubble_focus_left_offset: -.125rem;
    --_ui5_TimelineItem_bubble_content_padding: var(--_ui5_tl_bubble_padding);
    --_ui5_TimelineItem_bubble_content_subtitle_padding_top: .375rem;
    --_ui5_TimelineItem_bubble_content_description_padding_top: .75rem;
    --_ui5_tl_bubble_padding: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, 1rem);
    --_ui5_tl_padding: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, 1rem 1rem 1rem .5rem);
    --_ui5_tl_li_margin_bottom: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, 1.625rem);
    --_ui5_timeline_tli_indicator_before_bottom: var(--_ui5-compact-size, -.75rem)  var(--_ui5-cozy-size, -1.5rem);
    --_ui5_timeline_tli_indicator_before_right: var(--_ui5-compact-size, -.5rem)  var(--_ui5-cozy-size, -1.625rem);
    --_ui5_timeline_tli_indicator_before_without_icon_bottom: var(--_ui5-compact-size, -1rem)  var(--_ui5-cozy-size, -1.875rem);
    --_ui5_timeline_tli_indicator_before_without_icon_right: var(--_ui5-compact-size, -.8125rem)  var(--_ui5-cozy-size, -1.9375rem);
    --_ui5_timeline_tli_indicator_after_top: var(--_ui5-compact-size, calc(-100% + .9375rem) )  var(--_ui5-cozy-size, calc(-100% - 1rem) );
    --_ui5_timeline_tli_indicator_after_height: var(--_ui5-compact-size, calc(100% - .75rem) )  var(--_ui5-cozy-size, calc(100% + 1rem) );
    --_ui5_timeline_tli_indicator_before_height: var(--_ui5-compact-size, calc(100% - 1.25rem) )  var(--_ui5-cozy-size, 100%);
    --_ui5_timeline_tli_horizontal_indicator_after_width: var(--_ui5-compact-size, var(--_ui5_timeline_tli_indicator_after_height))  var(--_ui5-cozy-size, calc(100% + .25rem) );
    --_ui5_timeline_tli_horizontal_indicator_after_left: var(--_ui5-compact-size, 1.8625rem)  var(--_ui5-cozy-size, 1.9375rem);
    --_ui5_timeline_tli_horizontal_without_icon_indicator_before_width: var(--_ui5-compact-size, var(--_ui5_timeline_tli_indicator_after_height))  var(--_ui5-cozy-size, calc(100% + .5rem) );
    --_ui5_timeline_tli_horizontal_indicator_before_width: var(--_ui5-compact-size, var(--_ui5_timeline_tli_indicator_after_height))  var(--_ui5-cozy-size, calc(100% + .5rem) );
    --_ui5_timeline_tli_icon_horizontal_indicator_after_width: var(--_ui5-compact-size, var(--_ui5_timeline_tli_indicator_after_height))  var(--_ui5-cozy-size, calc(100% + .25rem) );
    --_ui5_timeline_tli_without_icon_horizontal_indicator_before_width: var(--_ui5-compact-size, calc(100% - .625rem) )  var(--_ui5-cozy-size, calc(100% + .375rem) );
    --_ui5_timeline_tli_horizontal_indicator_short_after_width: var(--_ui5-compact-size, calc(100% - 1rem) )  var(--_ui5-cozy-size, 100%);
    --ui5_upload_collection_drag_overlay_border: .1875rem dashed var(--sapContent_ForegroundBorderColor);
    --ui5_upload_collection_drop_overlay_border: .1875rem solid var(--sapContent_HelpColor);
    --ui5_upload_collection_drop_overlay_background: transparent;
    --ui5_upload_collection_thumbnail_size: 3rem;
    --ui5_upload_collection_thumbnail_margin_inline_end: .75rem;
    --ui5_upload_collection_small_size_buttons_margin_block_start: .5rem;
    --ui5_upload_collection_small_size_buttons_margin_inline_start: 0;
    --ui5_upload_collection_drag_overlay_text_color: var(--sapContent_NonInteractiveIconColor);
    --ui5_upload_collection_drag_overlay_icon_color: var(--sapContent_NonInteractiveIconColor);
    --ui5_upload_collection_drag_overlay_border_radius: 0;
    --ui5_upload_collection_drag_overlay_opacity: .8;
    --_ui5_vsd_header_container: var(--_ui5-compact-size, 2.5rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_vsd_sub_header_container_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_vsd_content_li_padding: .375rem;
    --_ui5_vsd_content_height: 23.4375rem;
    --_ui5_vsd_expand_content_height: var(--_ui5-compact-size, 25.4375rem)  var(--_ui5-cozy-size, 26.1875rem);
    --_ui5_wiz_content_item_wrapper_padding: 1rem;
    --_ui5_wiz_content_item_wrapper_bg: var(--sapGroup_ContentBackground);
    --_ui5_wiz_tab_focus_outline: .125rem dotted var(--sapContent_FocusColor);
    --_ui5_wiz_tab_selected_bg: var(--sapContent_Selected_Background);
    --_ui5_wiz_tab_border: 1px solid var(--sapContent_Selected_ForegroundColor);
    --_ui5_wiz_tab_selection_line: var(--sapTextColor);
    --_ui5_wiz_tab_icon_color: var(--sapTextColor);
    --_ui5_wiz_tab_active_separator_color: var(--sapContent_Selected_ForegroundColor);
    --_ui5_wiz_tab_title_color: var(--sapContent_LabelColor);
    --_ui5_wiz_tab_title_font_family: var(--sapFontFamily);
    --_ui5_wiz_tab_focus_border_radius: 0;
    --_ui5_shellbar_logo_outline_color: var(--sapContent_ContrastFocusColor);
    --_ui5_shellbar_logo_outline: var(--sapContent_FocusWidth) var(--sapContent_FocusStyle) var(--_ui5_shellbar_logo_outline_color);
    --_ui5_shellbar_button_box_shadow: none;
    --_ui5_shellbar_button_box_shadow_active: none;
    --_ui5_shellbar_button_active_color: var(--sapShell_Active_TextColor);
    --_ui5_shellbar_search_field_background: var(--sapShellColor);
    --_ui5_shellbar_search_field_border: .0625rem solid var(--sapShell_InteractiveBorderColor);
    --_ui5_shellbar_search_field_box_shadow: none;
    --_ui5_shellbar_search_field_color: var(--sapShell_TextColor);
    --_ui5_shellbar_search_field_width: 25rem;
    --_ui5_shellbar_input_focus_outline_color: inherit;
    --_ui5_shellbar_overflow_container_middle_height: 2.5rem;
    --_ui5_shellbar_image_button_border_radius: 50%;
    --_ui5-shellbar-content-margin-start: .5rem;
    --_ui5-shellbar-overflow-button-margin: .5rem;
    --_ui5-shellbar_separator-color: var(--sapToolbar_SeparatorColor);
    --_ui5-shellbar_cancel-button-color: var(--sapButton_Lite_TextColor);
    --_ui5_dynamic_page_footer_spacer: 4rem;
    --_ui5_dynamic_page_title_padding_S: .5rem 1rem;
    --_ui5_dynamic_page_title_padding_M: .5rem 2rem;
    --_ui5_dynamic_page_title_padding_L: .5rem 2rem;
    --_ui5_dynamic_page_title_padding_XL: .5rem 3rem;
    --_ui5_dynamic_page_header_padding_S: .5rem 1rem .125rem;
    --_ui5_dynamic_page_header_padding_M: 1rem 2rem;
    --_ui5_dynamic_page_header_padding_L: 1rem 2rem;
    --_ui5_dynamic_page_header_padding_XL: 1rem 3rem;
    --_ui5_dynamic_page_content_padding_S: 1rem 0 0;
    --_ui5_dynamic_page_content_padding_M: 1rem 1rem 0;
    --_ui5_dynamic_page_content_padding_L: 1rem 1rem 0;
    --_ui5_dynamic_page_content_padding_XL: 1rem 2rem 0;
    --ui5_dynamic_page_background: var(--sapBackgroundColor);
    --_ui5_dynamic_page_title_padding_top: .5rem;
    --_ui5_dynamic_page_title_padding_bottom: .5rem;
    --_ui5_dynamic_page_title_min_height: 4rem;
    --_ui5_dynamic_page_title_focus_outline: var(--sapContent_FocusWidth) var(--sapContent_FocusStyle) var(--sapContent_FocusColor);
    --_ui5_dynamic_page_title_focus_outline_offset: -.0625rem;
    --_ui5_dynamic_page_title_breadcrumbs_padding_top: .5rem;
    --_ui5_dynamic_page_title_breadcrumbs_padding_bottom: .25rem;
    --_ui5_dynamic_page_title_heading_padding_top: .3125rem;
    --_ui5_dynamic_page_title_subheading_margin_top: .25rem;
    --_ui5_dynamic_page_title_hover_background: var(--sapObjectHeader_Hover_Background);
    --_ui5_dynamic_page_snapped_title_on_mobile_line_height: 2rem;
    --_ui5_dynamic_page_snapped_title_on_mobile_min_height: 2rem;
    --_ui5_dynamic_page_header_background_color: var(--sapObjectHeader_Background);
    --_ui5_dynamic_page_header-actions-box-shadow: var(--sapContent_Shadow0);
    --_ui5_dynamic_page_header-box-shadow: var(--sapContent_HeaderShadow);
    --_ui5_dynamic_page_actions-lines-color: var(--sapObjectHeader_BorderColor);
    --_ui5_dynamic_page_header-actions-background: var(--sapObjectHeader_Background);
    --_ui5_dynamic_page_header-actions-color: var(--sapButton_TextColor);
    --_ui5_dynamic_page_header-actions-background-pressed: var(--_ui5_dynamic_page_header-actions-background);
    --_ui5_dynamic_page_header-actions-color-pressed: var(--_ui5_dynamic_page_header-actions-color);
    --_ui5_timeline_tlgi_line_horizontal_height: 16.375rem;
    --_ui5_timeline_tlgi_root_horizontal_height: var(--_ui5-compact-size, 20.90625rem)  var(--_ui5-cozy-size, 21.53125rem);
    --_ui5_timeline_tlgi_compact_icon_before_height: var(--_ui5-compact-size, calc(100% + 1.5rem) ) var(--_ui5-cozy-size, var(--_ui5-f2d95f8));
    --_ui5_timeline_tlgi_horizontal_line_placeholder_before_width: var(--_ui5-compact-size, var(--_ui5_timeline_tlgi_compact_icon_before_height)) var(--_ui5-cozy-size, var(--_ui5-f2d95f8));
    --_ui5_timeline_tlgi_horizontal_compact_root_margin_left: var(--_ui5-compact-size, .5rem) var(--_ui5-cozy-size, var(--_ui5-f2d95f8));
    --_ui5_timeline_tlgi_compact_root_gap: var(--_ui5-compact-size, .5rem) var(--_ui5-cozy-size, var(--_ui5-f2d95f8))}
`